var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentsMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "folder_copy_FILL0_wght200_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.625 19.9264C3.175 19.9264 2.79167 19.768 2.475 19.4514C2.15833 19.1347 2 18.7514 2 18.3014V8.22637H3V18.3014C3 18.4847 3.05833 18.6347 3.175 18.7514C3.29167 18.868 3.44167 18.9264 3.625 18.9264H19.05V19.9264H3.625ZM6.625 16.9264C6.175 16.9264 5.79167 16.768 5.475 16.4514C5.15833 16.1347 5 15.7514 5 15.3014V4.77637C5 4.32637 5.15833 3.94303 5.475 3.62637C5.79167 3.3097 6.175 3.15137 6.625 3.15137H12L13.225 4.37637H20.375C20.825 4.37637 21.2083 4.5347 21.525 4.85137C21.8417 5.16803 22 5.55137 22 6.00137V15.3014C22 15.7514 21.8417 16.1347 21.525 16.4514C21.2083 16.768 20.825 16.9264 20.375 16.9264H6.625ZM6.625 15.9264H20.375C20.5583 15.9264 20.7083 15.868 20.825 15.7514C20.9417 15.6347 21 15.4847 21 15.3014V6.00137C21 5.81803 20.9417 5.66803 20.825 5.55137C20.7083 5.4347 20.5583 5.37637 20.375 5.37637H12.825L11.6 4.15137H6.625C6.44167 4.15137 6.29167 4.2097 6.175 4.32637C6.05833 4.44303 6 4.59303 6 4.77637V15.3014C6 15.4847 6.05833 15.6347 6.175 15.7514C6.29167 15.868 6.44167 15.9264 6.625 15.9264ZM6 15.9264V4.15137V15.9264Z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsMenuIcon);
export default __webpack_public_path__ + "static/media/documents-menu-icon.c9b5901a0318583cdb7b2f339a8cb096.svg";
export { ForwardRef as ReactComponent };